import { YouTubeDebugPage } from "@/components/debugging/youtube-debug-pages";

export default function DebugEmbeddedYouTubeStep04Page() {
  return <YouTubeDebugPage stepNumber="04" />;
}
